export default class AddNewRegistryCtrl {

	constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
		// constants
		const regexp = {
			image   : /^(jpg|png|jpeg|bmp|gif)$/,
			audio   : /^(mp3|mpeg-4|wma)$/,
			video   : /^(mp4|mkv|avi|wmv)$/,
			document: /^(doc|docx|xls|xlsx|pdf)$/,
		}
		var registryVm = this
		const shared = PortfolioModalSrv.getVariable()
		const stylesClass = [ '', 'azul text-blanco' ]

		registryVm.userId = shared.userId
		registryVm.startDate = shared.startDate
		registryVm.endDate = shared.endDate
    
		// variables
		registryVm.itemConfig = GlobalConfig.itemListConfig
		registryVm.globalFileTypes = GlobalConfig.portfolioConfig.fileTypes
		registryVm.comment = ''
		registryVm.fileName = ''
		registryVm.attachFile = ''  
		registryVm.classTitle = 'col-md-3'
		registryVm.loading = false
		registryVm.errorMsg = false 
		registryVm.errorMsgFileType = ''
		registryVm.disableButtonUpload = true
		registryVm.showUploader = false
		registryVm.acceptFileType = ''
		registryVm.evidencesLinks = []
		registryVm.registryTypes = [
			{ registryId: registryVm.itemConfig.idReflection, registryName: registryVm.itemConfig.nameReflection },
			{ registryId: registryVm.itemConfig.idEvidence, registryName: registryVm.itemConfig.nameEvidence },
		]
		registryVm.fileTypes = []
		registryVm.evidencesTypes = []                          
		registryVm.isRegistry = true
		registryVm.isLinking = false
		registryVm.isAddingEvidence = false
		registryVm.disableButtonAdd = false
		registryVm.STATIC_IMAGE_URL = true

		// methods declaration
		registryVm.close = close
		registryVm.addRegistry = addRegistry
		registryVm.setClassTitle = setClassTitle
		registryVm.showErrorMessages = showErrorMessages
		registryVm.hasError = hasError
		registryVm.validateForm = validateForm    
		registryVm.remove = remove
		registryVm.cancel = cancel
		registryVm.linkEvidence = linkEvidence
		registryVm.showEvidencesToLink = showEvidencesToLink
		registryVm.setEvidence = setEvidence
		registryVm.removeLink = removeLink
		registryVm.showAddEvidenceToLink = showAddEvidenceToLink
		registryVm.addLinkToReflection = addLinkToReflection
		registryVm.setFilterUploader = setFilterUploader
		registryVm.openFileSelector = openFileSelector
		registryVm.uploadFile = uploadFile

		activate()
    
		// initial functions
		function activate() {
			PortfolioSrv.getBasicsRegistry.get().$promise.then((dataReturn) => {
				if (dataReturn.status) {
					registryVm.fileTypes = dataReturn.fileTypes
					registryVm.evidencesTypes = dataReturn.evidencesTypes
				}
			})
			getEvidences()
		}

		function getEvidences() {
			let header = {
				userId   : registryVm.userId,
				startDate: registryVm.startDate,
				endDate  : registryVm.endDate,
			}

			PortfolioSrv.getEvidences.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {          
					registryVm.evidences = dataReturn.data
				}
			}, function (data) {
				console.log(data)
			})
		}

		function close () {
			PortfolioModalSrv.setVariable({ status: false })

			return $mdDialog.hide()
		}  

		// methos for add elements

		function addRegistry () {
			registryVm.disableButtonAdd = true
			let header = {
				userId     : registryVm.userId,
				description: registryVm.description,
				title      : registryVm.title,
			}

			if (registryVm.itemConfig.idReflection == registryVm.registryId) {
				header.isEnlighted = (registryVm.blogIsEnlighted ? 1 : 0)
				header.evidencesLinks = registryVm.evidencesLinks
				addReflection(header)
			} else {
				header.idSubitem = registryVm.evidenceType
				header.fileType = registryVm.fileTypeId
				header.fileName = registryVm.attachFile 
				addEvidence(header)
			}
		}

		function addEvidence(evidence) {
			PortfolioSrv.addEvidence.add(evidence).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					registryVm.disableButtonAdd = false
					PortfolioModalSrv.setVariable({ status: dataReturn.status })

					return $mdDialog.hide()      
				}
			})
		}

		function addReflection(reflection) {
			PortfolioSrv.addReflection.add(reflection).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					registryVm.disableButtonAdd = false
					PortfolioModalSrv.setVariable({ status: dataReturn.status })

					return $mdDialog.hide()
				}
			})
		}

		function showEvidencesToLink() {
			registryVm.errorMsgLinkEvidence = false
			registryVm.isAddingEvidence = false
			registryVm.isLinking = true
			registryVm.isRegistry = false      
		}

		function showAddEvidenceToLink() {
			registryVm.errorMsgLinkEvidence = false
			registryVm.isAddingEvidence = true
			registryVm.isLinking = false
			registryVm.isRegistry = false  

			registryVm.showUploader = false
			registryVm.descriptionLinkEvidence = null
			registryVm.titleLinkEvidence = null
			registryVm.evidenceType = null
			registryVm.fileTypeId = null
			registryVm.fileName = null
			remove()
		}

		// methods for link evidence to a new reflection
		function linkEvidence() {
			if (registryVm.selectedEvidence) {
				let header = {
					blogId  : registryVm.selectedEvidence.evidence.blogId,
					title   : registryVm.selectedEvidence.evidence.blogTitle,
					filetype: registryVm.selectedEvidence.evidence.blogFileType,
				}

				registryVm.evidencesLinks.push(header)
				cancel()
			} else {
				registryVm.errorMsgLinkEvidence = true
			}
		}    

		function setEvidence(evidence, index) {
			if (registryVm.selectedEvidence) {
				registryVm.evidences[registryVm.selectedEvidence.pos].isSelected = stylesClass[0]
				registryVm.selectedEvidence = {
					evidence: evidence,
					pos     : index,
				}
				evidence.isSelected = stylesClass[1]
			} else {
				registryVm.selectedEvidence = {
					evidence: evidence,
					pos     : index,
				}
				evidence.isSelected = stylesClass[1]
			}

			registryVm.errorMsgLinkEvidence = false
		}  

		function removeLink(index) {
			registryVm.evidencesLinks.splice(index, 1) 
		}

		function cancel () {
			registryVm.isAddingEvidence = false
			registryVm.isLinking = false
			registryVm.isRegistry = true

			if (registryVm.evidences[registryVm.selectedEvidence.pos]) {
				registryVm.evidences[registryVm.selectedEvidence.pos].isSelected = stylesClass[0]
			}
 
			registryVm.selectedEvidence = null

			registryVm.descriptionLinkEvidence = null
			registryVm.titleLinkEvidence = null
			registryVm.evidenceType = null
			registryVm.fileTypeId = null
			registryVm.fileName = null
		}

		// methods to add new evidence, and link to reflection
		function addLinkToReflection() {
			registryVm.disableButtonAdd = true
			let header = {
				userId     : registryVm.userId,
				description: registryVm.descriptionLinkEvidence,
				title      : registryVm.titleLinkEvidence,
				idSubitem  : registryVm.evidenceType,
				fileType   : registryVm.fileTypeId,
				fileName   : registryVm.fileName, //este valor debe obtener cuando el archivo sea adjuntado
			}

			PortfolioSrv.addEvidence.add(header).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					let addedEvidence = {
						blogId      : dataReturn.reflectionId,
						blogTitle   : header.title,
						blogFileType: header.fileType,
					}
          
					registryVm.selectedEvidence = {
						evidence: addedEvidence,
						pos     : 0,
					} 
					linkEvidence()
					registryVm.disableButtonAdd = false
				}
			})
		}

		//upload methods
		function setFilterUploader() {
			let name = ''
			let extensions = '' 
			let pattern
 
			if (isImageType(registryVm.fileTypeId)) {
				name = 'imageFilter'
				extensions = '|jpg|png|jpeg|bmp|gif|'
				registryVm.acceptFileType = 'image/*'
				pattern = regexp.image
			}

			if (isAudioType(registryVm.fileTypeId)) {
				name = 'audioFilter'
				extensions = '|mp3|mpeg-4|wma|ogg|'
				registryVm.acceptFileType = 'audio/*'
				pattern = regexp.audio
			}

			if (isVideoType(registryVm.fileTypeId)) {
				name = 'videoFilter'
				extensions = '|mp4|mkv|avi|wmv|'
				registryVm.acceptFileType = 'video/*'
				pattern = regexp.video
			}

			if (isDocumentType(registryVm.fileTypeId)) {
				name = 'documentFilter'
				extensions = '|doc|docx|xls|xlsx|pdf|ppt|pptx|'
				registryVm.acceptFileType = 'application/pdf,application/vnd.ms-excel,application/msword'
				pattern = regexp.document
			}

			uploader.filters.pop()
			uploader.filters.push({
				name: name,
				fn  : function(item, options) {
					var type = '|' + item.name.slice(item.name.lastIndexOf('.') + 1) + '|'

					return extensions.indexOf(type) !== -1
				},
			})    
			registryVm.showUploader = true
			$('#inputFileUpload').val(null)
			$('#inputFileUpload2').val(null)
			registryVm.disableButtonUpload = true

			if (registryVm.attachFile != '') {
				checkExtensionFile(registryVm.fileTypeId, registryVm.attachFile, pattern)
			}
		}

		function checkExtensionFile(fileType, filename, pattern) {
			let ext = filename.substring(filename.lastIndexOf('.') + 1)

			if (pattern.test(ext)) {
				registryVm.errorMsgFileType = ''
			} else {
				registryVm.errorMsgFileType = 'El archivo adjunto no es el de tipo seleccionado'
			}
		}

		var uploader = $scope.uploader = new FileUploader({
			url: SERVICE_URL_CONSTANT.rosario + '/file/uploadFilePortfolio?userId=' + registryVm.userId, 
		})    

		// a sync filter
		uploader.filters.push({
			name: 'syncFilter',
			fn  : function(item /*{File|FileLikeObject}*/, options) {
				return this.queue.length < 10
			},
		})

		// an async filter
		uploader.filters.push({
			name: 'asyncFilter',
			fn  : function(item, options, deferred) {
				setTimeout(deferred.resolve, 1e3)
			},
		})

		uploader.filters.push({
			name: 'emptyFilter',
			fn  : function(item, options) {
				return true
			},
		})

		uploader.onWhenAddingFileFailed = function(item, filter, options) {
			registryVm.errorMsgFileType = 'El archivo no es el de tipo seleccionado'
			registryVm.disableButtonUpload = true
			$('#inputFileUpload').val(null)
			$('#inputFileUpload2').val(null)
		}

		uploader.onAfterAddingFile = function(fileItem) {
			registryVm.uploadFile()
			registryVm.errorMsgFileType = ''
			registryVm.disableButtonUpload = false
		}

		uploader.onSuccessItem = function(fileItem, response, status, headers) {
			if (response.status) {
				registryVm.loading = false
				registryVm.fileName = response.blobFileName
				registryVm.attachFile = fileItem.file.name 
				registryVm.errorMsg = false
			}
		}
		uploader.onErrorItem = function(fileItem, response, status, headers) {
			registryVm.errorMsg = true
		}

		uploader.onCompleteItem = function(fileItem, response, status, headers) {
			setTimeout(() => {
				registryVm.STATIC_IMAGE_URL = false
			}, 3000)
		}

		uploader.onBeforeUploadItem = function(item) {
			let header = {
				userId: registryVm.userId,
			}

			item.formData.push(header)
			registryVm.loading = true
			registryVm.errorMsg = false 
		}

		function remove() {
			registryVm.attachFile = ''
			uploader.clearQueue()
			registryVm.STATIC_IMAGE_URL = true
			registryVm.loading = false
			registryVm.errorMsg = false 
			registryVm.fileName = ''
			$('#inputFileUpload').val(null)
			$('#inputFileUpload2').val(null)
		}

		//forms methods
		function hasError (input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error'
			}
		}

		function showErrorMessages (input) {
			return input.$dirty || input.$touched
		}

		function validateForm (form) {
			if (registryVm.itemConfig.idEvidence == registryVm.registryId) {
				return form.$invalid || registryVm.fileName == '' || registryVm.errorMsgFileType != ''
			} else {
				if (registryVm.isAddingEvidence) {
					return form.$invalid || registryVm.fileName == '' || registryVm.errorMsgFileType != ''
				} else {
					return form.$invalid
				}
			}
		}

		//utils functions
		function setClassTitle() {
			if (registryVm.itemConfig.idEvidence == registryVm.registryId) {
				registryVm.classTitle = 'col-md-3'
			} else {
				registryVm.classTitle = 'col-md-3'
			}
		}

		function isImageType(fileTypeId) {
			return fileTypeId == registryVm.globalFileTypes.image
		}

		function isDocumentType(fileTypeId) {
			return fileTypeId == registryVm.globalFileTypes.document
		}

		function isVideoType(fileTypeId) {
			return fileTypeId == registryVm.globalFileTypes.video
		}

		function isAudioType(fileTypeId) {
			return fileTypeId == registryVm.globalFileTypes.audio
		}

		function openFileSelector() {
			let inputFile1 = document.getElementById('inputFileUpload')

			if (inputFile1) {
				inputFile1.click()
			} else {
				document.getElementById('inputFileUpload2').click()
			}
		}

		function uploadFile() {
			if (uploader.queue.length) {
				if (!hasWhiteSpaceAccentOrN) {
					uploader.queue[0].upload()
				} else {
					uploader.queue[0].file.name = parseAndCleanFileName(uploader.queue[0].file.name)
					uploader.queue[0].upload()
				}
			}
		}

		function parseAndCleanFileName(fileName) {
			let removeN = fileName.replace(/[ñÑ]/g, 'n')
			let removeSpaces = removeN.replace(/\s/g, '_')

			return removeSpaces.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
		}

		function hasWhiteSpaceAccentOrN(fileName) {
			const regex = /[ \u00A0-\uFFFFñÑ]/

			return regex.test(fileName)
		}
	}

}

AddNewRegistryCtrl.$inject = [ '$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 
	'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/addNewRegistryCtrl.js